import { Box, Button, CircularProgress, Menu, MenuItem, Tooltip, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import { Icons } from '../../utils/utilities'

const DepartmentSelect = ( { buttonStyles = {}, disabled, selectedDepartment, handleDepartmentChange, departments, showAll = true, loading = false } ) => {

    const [departmentSelectOpen, setDepartmentSelectOpen] = useState( false )

    const departmentSelectRef = useRef()


    const handleSelect = val => {
        setDepartmentSelectOpen( false )
        handleDepartmentChange( val )
    }

    return (
        <Box>
            <Tooltip disableInteractive title={disabled ? "Select Institute to filter by department" : "Filter by department"} >
                <Box component="span">
                    <Button size='small' disabled={disabled} onClick={() => setDepartmentSelectOpen( true )} ref={departmentSelectRef} endIcon={loading ? <CircularProgress size={14} /> : Icons.default.KeyboardArrowDownIcon} variant='contained' disableElevation sx={{ height: "40px", '&:disabled': { pointerEvents: "all", cursor: disabled && "not-allowed !important", ...( buttonStyles?.disabled || {} ) }, background: `linear-gradient(125.39deg, #139CFF -32.54%, #C54097 110.4%)`, opacity: disabled ? 0.6 : 1, ...( buttonStyles || {} ) }} >
                        <Typography variant='subtitle2' color={disabled ? buttonStyles?.disabled?.color || "lightgray" : buttonStyles?.color || "white"}>{( selectedDepartment === "all" || !selectedDepartment ) ? "Department" : departments?.find( d => `${d.department_id || "ndina"}-${d.legacy_dept_id || "ldina"}` === selectedDepartment )?.department_name}</Typography>
                    </Button>
                </Box>
            </Tooltip>
            <Menu anchorEl={departmentSelectRef.current} open={departmentSelectOpen} onClose={() => setDepartmentSelectOpen( false )}>
                {showAll && <MenuItem dense sx={{ fontSize: "12px" }} onClick={() => handleSelect( "all" )} value="all">All</MenuItem>}
                {departments.map( ( dept, index ) => {
                    const deptFilterId = `${dept.department_id || "ndina"}-${dept.legacy_dept_id || "ldina"}`
                    return (
                        <MenuItem selected={deptFilterId === selectedDepartment} dense sx={{ fontSize: "12px", textTransform: "capitalize" }} onClick={() => handleSelect( deptFilterId )} key={`dept-${index + 1}`}>{dept?.department_name?.toLowerCase()}</MenuItem>
                    )
                } )}
            </Menu>
        </Box>
    )
}

export default DepartmentSelect
